module.exports = __webpack_public_path__ + "img/icon.f69c00b0.png";